/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SummarizationsControllerFindAllQueryResponse, SummarizationsControllerFindAllPathParams, SummarizationsControllerFindAllQueryParams, SummarizationsControllerFindAll401, SummarizationsControllerFindAll403 } from "../../models/documentSummariesController/SummarizationsControllerFindAll";

function getSummarizationsControllerFindAllUrl(documentId: SummarizationsControllerFindAllPathParams["documentId"], renditionId: SummarizationsControllerFindAllPathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/summaries` as const }  
  return res
}

/**
 * @description Returns summaries with JSON:API pagination, sorting, and filtering
 * @summary List all summaries for a rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/summaries}
 */
export async function summarizationsControllerFindAll(documentId: SummarizationsControllerFindAllPathParams["documentId"], renditionId: SummarizationsControllerFindAllPathParams["renditionId"], params?: SummarizationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SummarizationsControllerFindAllQueryResponse, ResponseErrorConfig<SummarizationsControllerFindAll401 | SummarizationsControllerFindAll403>, unknown>({ method : "GET", url : getSummarizationsControllerFindAllUrl(documentId, renditionId).url.toString(), params, ... requestConfig })  
  return res.data
}